import React, { Component, Fragment } from 'react';
import './GrowthCharsMetricTable.css';

class GrowthCharsMetricsRow extends Component {

  formatPercent(number) {
    return (
      (number !== null && isNaN(number) === false) ? `${parseFloat(number * 100).toFixed(2)}%` : '-'
    );
  }

  asOfDate() {
    const {
      data
    } = this.props;
    const fundsWithAggs = data.filter((x) => x.aggregateFundamentals !== null);
    if (fundsWithAggs.length > 0) {
      const fund = fundsWithAggs[0];
      const value = fund['aggregateFundamentals'][fund['aggregateFundamentals'].length - 1];
      return new Date(value.date).toLocaleString().split(',')[0].split(' ')[0];
    } else {
      return '';
    }
  }


  renderFundTypeCell = (fund, url) => {
    if (fund.type === 'BMK') {
      return <td className='textLeft'>{fund.ticker.toUpperCase()}</td>;
    } else if (fund.type === 'BLEND') {
      return <td className='textLeft'>-</td>;
    } else {
      return (
        <td width='70'>
          <a className='textLeftTicker' href={url} target='_new'>{fund.ticker}</a>
        </td>
      );
    }
  };

  render() {
    const {
      fund,
      chartType
    } = this.props;

    if (fund.aggregateFundamentals) {
      const fundamentals = fund.aggregateFundamentals[fund.aggregateFundamentals.length - 1];
      const keys = fundamentals.keys
      const values = fundamentals.values

      var searchStr = chartType
      let metricPeriod = ['1y', '3y', '5y']
      var charsMetricsKeys = [];
      var charsMetricsValues = [];


      for (const element of metricPeriod) {
        let med = 'med_' + searchStr + element;

        let k = keys.indexOf(med);
        charsMetricsKeys.push(med);
        let weight = 'wgt_avg_' + searchStr + element;
        charsMetricsValues.push(values[k]);
        let kk = keys.indexOf(weight);
        charsMetricsKeys.push(weight);
        charsMetricsValues.push(values[kk]);
      }
    }

    if (fund.aggregateFundamentals === null) {
      return null;
    }

    const url = fund.fundPageURL ? fund.fundPageURL : fund.msUrl;
    return (
      <Fragment>
        <tr className='greyline'>
          {this.renderFundTypeCell(fund, url)}
          {['BMK', 'WTIDX'].includes(fund.type) ?
            <td width='300' className='textLeft'>
              {fund.name.replace(/&amp;/g, '&')}
            </td>
            :
            <td width='300' className='textLeft'>
              {`${fund.name.replace(/&amp;/g, '&')} (NAV)`}
            </td>
          }

          <td className='textCenter'>
            {this.formatPercent(charsMetricsValues[0])}
          </td>
          <td className='textCenter'>
            {this.formatPercent(charsMetricsValues[2])}
          </td>
          <td className='textCenter'>
            {this.formatPercent(charsMetricsValues[4])}
          </td>
          <td className='textCenter'>
            {this.formatPercent(charsMetricsValues[1])}
          </td>
          <td className='textCenter'>
            {this.formatPercent(charsMetricsValues[3])}
          </td>
          <td className='textCenter'>
            {this.formatPercent(charsMetricsValues[5])}
          </td>
        </tr>
      </Fragment>
    );
  }
}

export default GrowthCharsMetricsRow;
